import LanguageManager from '../../language_manager/language_manager';

/**
 * This files contains all the different client errors
 */
export default class {
    static get UNSUPPORTED_BROWSER() {
        return {
            title: LanguageManager.get('error_571111_unsupported_browser_title'),
            message: LanguageManager.get('error_571111_unsupported_browser_message'),
            code: 571111
        };
    }

    static get INVALID_DOMAIN() {
        return {
            title: LanguageManager.get('error_571119_invalid_domain_title'),
            message: LanguageManager.get('error_571119_invalid_domain_message'),
            stopPlayer: true,
            logSplunk: false,
            logYoubora: false
        };
    };

    static get INVALID_PLAYKEY() {
        return {
            code: 571119,
            message: LanguageManager.get('error_571119_invalid_configuration'),
            redirect: true
        };
    };

    static get MISSING_SERIES_INFO() {
        return {
            code: 571119,
            message: LanguageManager.get('error_571119_invalid_configuration'),
            redirect: true
        };
    };

    static get INVALID_URI() {
        return {
            code: 571119,
            message: LanguageManager.get('error_571119_generic'),
            stopPlayer: true
        };
    };

    static get REDIRECT() {
        return {
            title: LanguageManager.get('redirect_title'),
            message: LanguageManager.get('redirect_message'),
            stopPlayer: true,
            logSplunk: false,
            logYoubora: false
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/error_handler/errors/client_errors.js